export default __webpack_public_path__ + "static/media/kc.fc293367.svg";